module.exports = __webpack_public_path__ + "f70bc45e09e291df81b427e921f21030.jpg";